import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索分类
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            六大精选分类，涵盖亚洲文化、娱乐、生活、美食、科技与旅行
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer group"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl ${colorMap[cat.color]} transition-transform duration-300 group-hover:scale-110`}
              >
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="font-heading text-sm font-semibold text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 text-center leading-relaxed">
                {cat.description.slice(0, 24)}...
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}